import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Radio,
    useDisclosure,
    Avatar,
    Image,
    Text,
  } from '@chakra-ui/react'
import myphoto from "./assets/myphoto.png"
import React from 'react'
import { Button } from '@chakra-ui/react'
import { Link as NavLinkes} from 'react-scroll';
import {BiMenu} from 'react-icons/bi'
export default function Drawerfun() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [placement, setPlacement] = React.useState('right')
  
    return (
      <>
        <Button  id="drawer" backgroundColor={"none"} onClick={onOpen}>
          <BiMenu />
        </Button>
        <Drawer placement={placement} onClose={onClose} isOpen={isOpen} size={"xs"}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader borderBottomWidth='1px'>PortFolio</DrawerHeader>
            <DrawerCloseButton />
            <DrawerBody>
            <Image
            textAlign={"center"}
            display={"block"}
            margin={"auto"}
                     height={"auto"}
                     width={"200px"}
                     borderRadius={"50%"}
                     border={"1px solid gray"}
                      src={myphoto}
                    />
                    
                    <NavLinkes to="home"
                    activeClass="active-draw" smooth spy
    
    
                  >
                    <Text className='path' onClick={()=>{
                        onClose()
                        }} >Home </Text>
    
                  </NavLinkes >
                  <hr style={{marginTop:"10px",marginBottom:"10px"}}/>
                    <NavLinkes to="about"
                     activeClass="active-draw" smooth spy
    
    
                  >
                    <Text className='path' onClick={()=>{
                        onClose()
                        }} >About </Text>
    
                  </NavLinkes >
                  <hr style={{marginTop:"10px",marginBottom:"10px"}}/>
                    <NavLinkes to="skills"
                     activeClass="active-draw" smooth spy
    
    
                  >
                    <Text className='path' onClick={()=>{
                        onClose()
                        }} >Skills </Text>
    
                  </NavLinkes >
           
                  <hr style={{marginTop:"10px",marginBottom:"10px"}}/>
                    <NavLinkes to="projects"
                     activeClass="active-draw" smooth spy
    
    
                  >
                    <Text className='path' onClick={()=>{
                        onClose()
                        }} >Projects </Text>
    
                  </NavLinkes >
           
                  <hr style={{marginTop:"10px",marginBottom:"10px"}}/>
                    <NavLinkes to="contact"
                     activeClass="active-draw" smooth spy
    
    
                  >
                    <Text  className='path' onClick={()=>{
                        onClose()
                        }} >Contact Us </Text>
    
                  </NavLinkes >
                 
                  <hr style={{marginTop:"10px",marginBottom:"10px"}}/>
            
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </>
    )
  }